import Image from 'next/image'

const SkeletonImage = () => {
  return (
    <Image
      alt="모두의주차장 로딩 이미지"
      src="/images/img_skeleton.png"
      sizes="100%"
      style={{ objectFit: 'cover' }}
      fill={true}
      unoptimized={true}
    />
  )
}

export default SkeletonImage
